import type { ColorScheme } from '@atlaskit/editor-plugin-show-diff/show-diff-plugin-type';
import { isExperimentEnabled } from '@atlaskit/platform-feature-experiments/is-experiment-enabled';

import type { AgentInfo } from '../../pm-plugins/decoration/reducer';
import { resolveTelepointerPresentation } from '../components/TelepointerAvatar/telepointerPresentation';

/**
 * Matches review diffs to the agent's streaming highlight. The redesign uses attribution
 * styling for deletions, including Rovo; its control cohort retains the plugin default.
 */
export const resolveReviewMomentDiffColorScheme = (
	agentInfo: AgentInfo | undefined,
): ColorScheme | undefined => {
	if (
		!isExperimentEnabled('platform_editor_agent_mentions') ||
		!isExperimentEnabled('platform_editor_agent_telepointer_redesign')
	) {
		return undefined;
	}

	const presentation = resolveTelepointerPresentation(agentInfo);
	if (presentation.telepointerAgentKind === 'rovo') {
		return 'purple';
	}
	return presentation.agentColor ?? 'gray';
};
